export const Image = (props) => (
    <img {...props} /> 
)